import React, { useEffect, useState } from "react";
import "./styles/globals.css";
import "./App.scss";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "./components/layout/Header";
import Sidebar from "./components/layout/Sidebar";

import Game from "./pages/Game";
import BetHistory from "./pages/BetHistory";

import MainLoading from "./components/layout/MainLoading";

import { AuthProvider } from "./context/AuthContext";

function AppContent() {
  const [path, setPath] = useState(window.location.pathname);
  const [loading, setLoading] = useState(true);

  const navigate = (to) => {
    window.history.pushState({}, "", to);
    setPath(to);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handlePopState = () => {
      setPath(window.location.pathname);
    };

    window.addEventListener("popstate", handlePopState);

    // Loader hide after 2 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      clearTimeout(timer);
    };
  }, []);

  let content;

  switch (path) {
    case "/history":
    case "/aviator-bethistory":
      content = <BetHistory navigate={navigate} />;
      break;

    case "/game":
    case "/":
    default:
      content = <Game navigate={navigate} />;
      break;
  }

  // Show loader
  if (loading) {
    return <MainLoading />;
  }

  return (
    <div id="aviator" className="app-shell">
      <Header navigate={navigate} />

      <Sidebar navigate={navigate} />

      <main className="route-area">
        {content}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />

      <ToastContainer
        position="top-center"
        autoClose={3000}
        theme="colored"
        newestOnTop
        limit={1}
        className="global-toast"
      />
    </AuthProvider>
  );
}